import React from 'react';

class Footer extends React.Component{
    render(){
        return(
            <div id="footer">
                <div id="footer-logo">
                    <h2 id="footer-logo-text">
                        Humourbaba
                    </h2>
                </div>
                <div id="get-to-know-us">
                    <h4>Get to Know Us</h4>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">About Us</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Contact Us</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Careers</a><br></br>
                </div>
                <div id="connect-with-us">
                    <h4>Connect with Us</h4>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Facebook</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Instagram</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Twitter</a><br></br>
                </div>
                <div id="customer-service">
                    <h4>Customer Service</h4>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">FAQs</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Offers</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Return Refund and Cancel</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Privacy Policy</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Terms and Conditions</a><br></br>
                </div>
                <div id="customer-service">
                    <h4>Customer Service</h4>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Fedex</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Bluedart</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Delhivery</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">DTDC</a><br></br>
                    <a href="https://www.linkedin.com/in/deepanshu-saini-197634193/">Aramex</a><br></br>
                </div>
            </div>
        )
    }
}

export default Footer;